/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import EntryExitDates from './EntryExitDates';
import { readRuleValue } from '../../utils/permitUtilsNew';
import { AVAILABILITY_KEY_MAP_FORMAT } from '../../constants/index';

const propTypes = {
    launchDetail: PropTypes.shape({
        entryDate: PropTypes.shape({}),
    }),
    onChangeStartDate: PropTypes.func.isRequired,
    handleLaunchDetailChange: PropTypes.func,
    permit: PropTypes.shape({}),
    issuance: PropTypes.shape({}),
    division: PropTypes.shape({}),
    isDisabled: PropTypes.bool,
    isStartDateChangeAllowed: PropTypes.bool,
    formValidationChange: PropTypes.func,
    validation: PropTypes.shape({}),
    displayValidationError: PropTypes.bool,
};

const defaultProps = {
    isDisabled: false,
    permit: {},
    issuance: {},
    division: {},
};

export default class PermitTripDates extends React.Component {
    renderEntry() {
        const entryDate = gnoment(this.props.launchDetail.entryDate).utc();

        return (
            <div>
                <h2 className={'h5'}>Entry Date</h2>
                <p>This permit is limited to one day.</p>
                <div className="grayed">
                    <b>Entry Date: </b>
                </div>
                <p className="grayed">{entryDate.format(AVAILABILITY_KEY_MAP_FORMAT)}</p>
                <hr />
            </div>
        );
    }

    renderEntryExit() {
        return (
            <EntryExitDates
                permit={this.props.permit}
                issuance={this.props.issuance}
                launchDetail={this.props.launchDetail}
                handleLaunchDetailChange={this.props.handleLaunchDetailChange}
                division={this.props.division}
                isDisabled={this.props.isDisabled}
                onChangeStartDate={this.props.onChangeStartDate}
                isStartDateChangeAllowed={this.props.isStartDateChangeAllowed}
                formValidationChange={this.props.formValidationChange}
                validation={this.props.validation}
                displayValidationError={this.props.displayValidationError}
            />
        );
    }

    render() {
        if (readRuleValue('ShowEntryDateOnly', this.props.permit)) {
            return this.renderEntry();
        }

        return this.renderEntryExit();
    }
}

PermitTripDates.propTypes = propTypes;
PermitTripDates.defaultProps = defaultProps;
